/**
 * Person / VisualArtwork Schema.org JSON-LD.
 * Injected once at layout level. Additional page-specific schemas can be added by pages.
 */
export default function PersonJsonLd() {
  const data = {
    "@context": "https://schema.org",
    "@type": "Person",
    name: "Colin Darke",
    alternateName: "The Ambidextrous Artist",
    jobTitle: "Artist",
    description:
      "Colin Darke is a Detroit-based American artist known internationally as \"The Ambidextrous Artist\" for making art in real time — often with both hands at once, sometimes creating different images with each hand. He has been making art for more than four decades. His work has reached hundreds of millions of views online and has been featured by Good Morning America and Ripley's Believe It or Not!",
    homeLocation: {
      "@type": "Place",
      name: "Detroit, Michigan, United States",
    },
    nationality: {
      "@type": "Country",
      name: "United States",
    },
    knowsAbout: [
      "Ambidextrous drawing",
      "Ambidextrous painting",
      "Expressionist painting",
      "Portraiture",
      "Detroit art community",
    ],
    subjectOf: [
      {
        "@type": "TVEpisode",
        name: "Ambidextrous artist wows TikTok with his unique skill",
        partOfSeries: { "@type": "TVSeries", name: "Good Morning America" },
        datePublished: "2021-10-28",
      },
      {
        "@type": "Book",
        name: "Ripley's Out of the Box!",
        publisher: { "@type": "Organization", name: "Ripley's Believe It or Not!" },
      },
    ],
  };
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}
